import React from "react";

const DownloadIcon = ({
  className = "",
  width = "14",
  height = "15",
  color = "#8F8F8F",
  restProps,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...restProps}
    >
      <path
        d="M6.39307 10C6.32739 10.0001 6.26235 9.98485 6.20166 9.95523C6.14098 9.92561 6.08584 9.88217 6.0394 9.82739C5.99296 9.77261 5.95613 9.70757 5.93102 9.63599C5.90591 9.5644 5.89301 9.48768 5.89307 9.41021V0.58979C5.89307 0.433368 5.94574 0.283352 6.03951 0.172745C6.13328 0.0621384 6.26046 0 6.39307 0C6.52567 0 6.65285 0.0621384 6.74662 0.172745C6.84039 0.283352 6.89307 0.433368 6.89307 0.58979V9.41021C6.89307 9.56663 6.84039 9.71665 6.74662 9.82725C6.65285 9.93786 6.52567 10 6.39307 10Z"
        fill={color}
      />
      <path
        d="M6.60354 10.515C6.42349 10.5153 6.24516 10.48 6.0788 10.4112C5.91243 10.3424 5.76131 10.2413 5.63411 10.1139L2.74082 7.22061C2.6404 7.12019 2.58398 6.98399 2.58398 6.84197C2.58398 6.69995 2.6404 6.56375 2.74082 6.46333C2.84125 6.3629 2.97745 6.30649 3.11947 6.30649C3.26148 6.30649 3.39769 6.3629 3.49811 6.46333L6.39139 9.35661C6.41925 9.38447 6.45233 9.40657 6.48873 9.42165C6.52513 9.43673 6.56414 9.44449 6.60354 9.44449C6.64294 9.44449 6.68195 9.43673 6.71835 9.42165C6.75475 9.40657 6.78782 9.38447 6.81568 9.35661L9.70897 6.46333C9.80998 6.36571 9.94528 6.31168 10.0857 6.31286C10.2262 6.31404 10.3606 6.37034 10.4599 6.46964C10.5593 6.56894 10.6157 6.70329 10.6169 6.84375C10.6182 6.98421 10.5642 7.11955 10.4667 7.22061L7.57297 10.1139C7.44574 10.2413 7.29461 10.3423 7.12825 10.4111C6.96189 10.48 6.78358 10.5153 6.60354 10.515Z"
        fill={color}
      />
      <path
        d="M12.1319 14.5984H1.2892C0.947409 14.598 0.619735 14.4482 0.378053 14.1819C0.13637 13.9157 0.000411796 13.5547 0 13.1782V9.4333C0 9.29122 0.0512319 9.15496 0.142425 9.05449C0.233619 8.95402 0.357303 8.89758 0.48627 8.89758C0.615237 8.89758 0.738922 8.95402 0.830115 9.05449C0.921308 9.15496 0.97254 9.29122 0.97254 9.4333V13.1782C0.972643 13.2706 1.00604 13.3593 1.0654 13.4247C1.12476 13.4901 1.20525 13.5269 1.2892 13.527H12.1319C12.2158 13.5269 12.2963 13.4901 12.3557 13.4247C12.415 13.3593 12.4484 13.2706 12.4485 13.1782V9.4333C12.4485 9.29122 12.4997 9.15496 12.5909 9.05449C12.6821 8.95402 12.8058 8.89758 12.9348 8.89758C13.0638 8.89758 13.1874 8.95402 13.2786 9.05449C13.3698 9.15496 13.4211 9.29122 13.4211 9.4333V13.1782C13.4206 13.5547 13.2847 13.9157 13.043 14.1819C12.8013 14.4482 12.4736 14.598 12.1319 14.5984Z"
        fill={color}
      />
    </svg>
  );
};

export default DownloadIcon;
